import { Box, Typography } from "@mui/material";
import { ProgrammeActions } from "model";

interface ProgrammeBannerProps {
  programme: ProgrammeActions;
  borderRadius?: string;
}

/**
 * Reusable component for rendering programme banner header.
 * Handles special banner images for specific programme GUIDs,
 * or displays programme name on default green background.
 */
export default function ProgrammeBanner({
  programme,
  borderRadius = "0px",
}: ProgrammeBannerProps) {
  return (
    <Box
      sx={{
        height: "120px",
        borderRadius,
        ...(programme.guid === "6vczLKixKSwPkIFP3JkkGD"
          ? {
              backgroundImage:
                'url("https://ruumi-dashboard-assets.ruumi.io/lidl-sustainable-beef-banner.png")',
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundColor: "#395499",
            }
          : programme.guid === "3UqQUHVbKY5CMBthVL5Ltq"
          ? {
              backgroundImage:
                'url("https://ruumi-dashboard-assets.ruumi.io/Pattemores.png")',
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "repeat",
              backgroundColor: "#ffffffff",
            }
          : programme.guid === "5OPgsM2LDKgFHqhLO4Kzpv"
          ? {
              backgroundImage:
                'url("https://ruumi-dashboard-assets.ruumi.io/County-Milk-2.png")',
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "repeat",
              backgroundColor: "#ffffffff",
            }
          : {
              backgroundColor: "#1C4321",
            }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {programme.guid !== "6vczLKixKSwPkIFP3JkkGD" &&
        programme.guid !== "3UqQUHVbKY5CMBthVL5Ltq" &&
        programme.guid !== "5OPgsM2LDKgFHqhLO4Kzpv" && (
          <Typography
            variant="h5"
            sx={{
              color: "white",
              fontWeight: 600,
              textAlign: "center",
              px: 2,
            }}
          >
            {programme.programmeName}
          </Typography>
        )}
    </Box>
  );
}
